import PageTitle from "../../components/PageTitle";
import StudentPersonalInfo from "./components/StudentPersonalInfo";
import { useUserState } from "../../context/UserContext";
import { useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/lab/TabList";
import Documents from "./components/StudentDocument";
import TabPanel from "@mui/lab/TabPanel";

const Subjects = () => {
  const { profile } = useUserState();
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <PageTitle
        title={`${profile?.first_name} ${profile?.last_name} Profile`}
        subtitle="View/Update your profile details "
      />
      <div className="page-content">
        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
              <Tab label="Personal Information" value="1" />
              <Tab label="Documents" value="2" />
            </Tabs>
          </div>
          <TabPanel value="1" className="tabpanel-overide"><StudentPersonalInfo /></TabPanel>
          <TabPanel value="2" className="tabpanel-overide"><Documents id={profile?.student_id} /></TabPanel>
        </TabContext>
      </div>
    </>
  );
};

export default Subjects;
